import { isEqual, merge } from 'lodash';

import { loggedInUserDataStore } from '../../../stores/loggedInUserDataStore';
import { ANGULAR_EVENT_KEYS } from '../../../constants/system/ANGULAR_EVENT_KEYS';
import { LOCAL_STORAGE_KEYS } from '../../../constants/system/LOCAL_STORAGE_KEYS';
import { broadcastEvent } from '../../angularUtils';
import { LoggedInUser } from '../../../interfaces/LoggedInUser';
import { DeepPartial } from '../../../../utils-types';
import { reloadOtherTabs } from '../../windowUtils';

export const updateUserInfo = (newLoggedInUserData: DeepPartial<LoggedInUser>) => {
  const currentUserData = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_KEYS.LOGGED_IN_USER) ?? 'null',
  );
  const userData = merge({}, currentUserData, newLoggedInUserData);

  // no-op when nothing changed, otherwise tabs reload each other in an infinite loop (LMP-5348)
  if (isEqual(userData, currentUserData)) {
    return;
  }

  localStorage.setItem(LOCAL_STORAGE_KEYS.LOGGED_IN_USER, JSON.stringify(userData));

  loggedInUserDataStore.setLoggedInUser(); // get data from localStorage

  broadcastEvent(ANGULAR_EVENT_KEYS.UPDATE_USER);
  reloadOtherTabs();
};
